import React from "react";
import Context from "../../../Context";
import List from "../../Misc/List";
import FieldsList from "../../Misc/FieldsList";
import Sortings from "../../Misc/Sortings";
import Filters from "../../Misc/Filters";
import { essenceClass } from "../../../essense";
import visualState from "../../../visualState";
import TaskListItem from "./TaskListItem";
import user from "../../../user";

let searchTimeout = null;

export default class TasksList extends React.Component {
  static contextType = Context;
  static fieldsStorageName = "templateListFields";
  constructor(props) {
    super(props);

    this.vState = new visualState("TaskList");
    let onlyMine = this.vState.read("onlyMine", true);

    let defaultFilter = this.filtersMakeDefault(this.props.mode, onlyMine);
    let showStateFilter = this.props.mode !== "completed";

    this.state = {
      onlyMine,
      pending: false,
      searchPending: false,
      search: [],
      customListKey: "",
      showStateFilter: showStateFilter,
      filters: {
        show: false,
        active: [],
        default: defaultFilter,
        all: [
          {
            id: "created",
            title: "По дате создания",
            kind: "range",
            active: false,
            value: [],
          },
        ],
      },
      fields: {
        all: [],
        active: [],
      },
      sortings: {
        all: [
          {
            id: "byLabelAsc",
            active: false,
            title: "По алфавиту",
            value: ["label ASC"],
          },
          {
            id: "byCreatedDesc",
            active: false,
            title: "По дате создания",
            value: ["created DESC"],
          },
        ],
        active: [],
      },
    };
  }
  componentDidMount() {
    this.loadInfo();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.mode !== this.props.mode) {
      this.filtersReset();
    }
  }

  onlyMineToggle = () => {
    this.setState(
      (state) => {
        let onlyMine = !state.onlyMine;
        this.vState.save({ onlyMine });
        return {
          onlyMine,
        };
      },
      () => {
        this.filtersReset(this.onFinish);
      }
    );
  };

  filtersReset = (callback = null) => {
    let defaultFilter = this.filtersMakeDefault(
      this.props.mode,
      this.state.onlyMine
    );
    let showStateFilter = false;
    this.setState(
      (state) => {
        let filters = this.filtersDeactivate(state.filters);
        filters.default = defaultFilter;
        filters.show = false;
        return { filters, showStateFilter };
      },
      () => {
        if (callback) {
          callback();
        }
      }
    );
  };

  filtersDeactivate(filters) {
    filters.active = [];
    if (Array.isArray(filters.all)) {
      filters.all.forEach((filter, index) => {
        filters.all[index].active = false;
        filters.all[index].activeVariants = [];
      });
    }
    return filters;
  }

  filtersMakeDefault = (mode, onlyMine) => {
    let defaultFilter = [];

    if (onlyMine) {
      defaultFilter.push({
        field: "executor",
        compare: "EQL",
        value: user.staffId || null,
      });
    }

    if (mode === "completed") {
      defaultFilter.push({
        field: "statecode",
        compare: "EQL",
        value: "completed",
      });
    }
    if (mode === "postponed") {
      defaultFilter.push({
        field: "statecode",
        compare: "EQL",
        value: "postponed",
      });
    }
    if (mode === "future") {
      defaultFilter.push({
        field: "statecode",
        compare: "EQL",
        value: "planned",
      });
    }
    if (mode === "current") {
      defaultFilter.push({
        field: "statecode",
        compare: "EQL",
        value: "enabled",
      });
    }
    if (mode === "expired") {
      defaultFilter.push({
        field: "statecode",
        compare: "EQL",
        value: "expired",
      });
    }

    return defaultFilter;
  };

  loadInfo = async () => {
    let essence = new essenceClass("task");

    let stateList = await essence.getStateList();
    if (Array.isArray(stateList)) {
      let variants = [];
      stateList.forEach((item) =>
        variants.push([
          item.label,
          [{ field: "statecode", compare: "EQL", value: item.code }],
        ])
      );
      this.setState((state) => {
        let filters = state.filters;
        filters.all.push({
          id: "statecode",
          title: "По статусу",
          kind: "dropdown",
          multiple: true,
          active: false,
          activeVariants: [],
          variants,
        });
        return { filters };
      });
    }

    let typeList = await essence.getTypeList();
    if (Array.isArray(typeList)) {
      let variants = [];
      typeList.forEach((item) =>
        variants.push([
          item.name,
          [{ field: "typecode", compare: "EQL", value: item.code }],
        ])
      );
      this.setState((state) => {
        let filters = state.filters;
        filters.all.push({
          id: "typecode",
          title: "По типу",
          kind: "dropdown",
          multiple: true,
          active: false,
          activeVariants: [],
          variants,
        });
        return { filters };
      });
    }
  };

  toggleFilters = (v) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.show = v;
      return { filters };
    });
  };

  handleFilters = (changedFilters) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.active = changedFilters;
      return { filters };
    });
  };
  handleFields = (changedFields) => {
    localStorage.setItem(this.fieldsStorageName, JSON.stringify(changedFields));
    this.setState((state) => {
      let fields = state.fields;
      fields.active = changedFields;
      return { fields };
    });
  };
  handleSortings = (chnagedSortings) => {
    this.setState((state) => {
      let sortings = state.sortings;
      sortings.active = chnagedSortings;
      return { sortings };
    });
  };
  handleSearch = (searchValue) => {
    this.setState({ searchPending: true });
    window.clearTimeout(searchTimeout);
    searchTimeout = window.setTimeout(() => {
      let search = searchValue
        ? [
            {
              lstr: "(",
              field: "label",
              compare: "IKE",
              value: `%${searchValue}%`,
              rstr: ")",
            },
          ]
        : [];
      this.setState({ searchPending: false, search });
    }, 1500);
  };

  onFinish = () => {
    this.setState({ customListKey: this.context.key() });
  };
  onRead = async (data) => {
    await this.context.api.q("/task/set", {
      id: data.id,
      read: true,
    });
  };
  onChange = async (data) => {
    await this.context.api.q("/task/set", data);
    this.onFinish();
  };

  onListLoadStart = () => {
    this.setState({ pending: true });
  };
  onListLoadEnd = () => {
    this.setState({ pending: false });
  };

  render() {
    let allFilters = this.state.filters.all.slice();
    if (!this.state.showStateFilter) {
      allFilters.forEach((filter, index) => {
        if (filter.id === "statecode") {
          allFilters.splice(index, 1);
        }
      });
    }

    let filters = (
      <div
        className={`${
          this.state.filters.show ? "d-flex" : "d-none"
        }  align-items-center justify-content-end mt-0 py-5 px-7 mb-2 border-bottom w-100 shadow-sm`}
      >
        <Filters
          key={JSON.stringify(allFilters)}
          changeFn={this.handleFilters}
          filters={allFilters}
        />
      </div>
    );

    return (
      <>
        <div className="card card-custom  ">
          <div className="card-header px-5 py-2">
            <div className="card-title w-100 mr-0 p-lg-0 py-5 d-block d-lg-flex align-items-center justify-content-between">
              <div className="text-nowrap d-inline-block mr-2">
                {this.state.searchPending ? (
                  <div className="spinner mr-10 d-inline-block"></div>
                ) : (
                  ""
                )}
                <input
                  className="form-control form-control-solid d-inline-block w-auto"
                  type="text"
                  placeholder="Поиск"
                  onChange={(e) => this.handleSearch(e.target.value)}
                />
              </div>

              <div>
                <div className="text-nowrap d-inline-block mr-4">
                  <label
                    title="Показывать  а в любом статусе"
                    className="checkbox text-muted font-italic"
                  >
                    <input
                      checked={this.state.onlyMine}
                      onChange={this.onlyMineToggle}
                      type="checkbox"
                    />
                    <span className="mr-2"></span>
                    Только мои задачи
                  </label>
                </div>

                <button
                  className="btn btn-light mr-2"
                  onClick={() => this.toggleFilters(!this.state.filters.show)}
                >
                  <i
                    className={`fa fa-filter p-0 ${
                      this.state.filters.show ? "text-primary" : "text-muted"
                    }`}
                  ></i>
                </button>
                <Sortings
                  changeFn={this.handleSortings}
                  sortings={this.state.sortings.all}
                />
              </div>
            </div>
          </div>
          {filters}
          <div className="card-body px-5">
            <List
              listKey="TasksList"
              key={this.state.customListKey}
              fulltext={JSON.stringify(this.state.search)}
              search={JSON.stringify(
                this.state.filters.active.concat(this.state.filters.default)
              )}
              sort={JSON.stringify(this.state.sortings.active)}
              fields={JSON.stringify(this.state.fields.active)}
              limit={20}
              keyField="id"
              path="/task/list"
              row={this.state.viewGrid}
              onLoadStart={this.onListLoadStart}
              onLoadEnd={this.onListLoadEnd}
            >
              <TaskListItem
                onRead={this.onRead}
                onFinish={this.onFinish}
                onChange={this.onChange}
              />
            </List>
          </div>
        </div>
      </>
    );
  }
}
